import React, { useEffect, useState } from "react";

// React router dom imports
import { BrowserRouter, Route } from "react-router-dom";

// redux
import { useDispatch, useSelector } from "react-redux";
import { cleanStore } from "./redux/actions/loginAction";

// Components imports
import AuthGuard from "./components/common/AuthGuard";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import BasicAccount from "./pages/BasicAccount";
import Processors from "./pages/Processors";
import Categories from "./pages/Categories";
import CreationWordDocument from "./pages/CreationWordDocument";
import RecordBook from "./pages/RecordBook";
import Papers from "./pages/Papers";
import NotArchivedPapers from "./pages/NotArchivedPapers";
import UserPanel from "./pages/UserPanel";
import CreateArchive from "./pages/CreateArchive";
import DestroyArchive from "./pages/DestroyArchive";
import Archive from "./pages/Archive/Archive";
import ReactDocx from "./pages/ReactDocx";
import ReactDocxArchive from "./pages/ReactDocxArchive";
import DocumentPatterns from "./pages/DocumentPatterns";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import AllUsers from "./pages/AllUsers";
import UserProfile from "./pages/UserProfile";
import EditPaper from "./pages/EditPaper";
import EditArchive from "./pages/EditArchive";
import ProtectedRoute from "./components/common/ProtectedRoute";
import AddArchive from "./pages/AddArchive";

import { setCertainCategoryValueTo0 } from "./redux/actions/papersActions";
import { manuallyTrigerRole } from "./redux/actions/currentUserActions";

// Scss imports
import css from "./App.module.scss";

import Cookies from "universal-cookie";

const cookies = new Cookies();

interface AppProps {}

const App: React.FC<AppProps> = () => {
  const dispatch = useDispatch();

  const [currentUserRole, setCurrentUserRole] = useState("");
  const currentUserData = useSelector(
    (state: any) => state.currentUser.currentUserData
  );

  useEffect(() => {
    if (currentUserData) {
      setCurrentUserRole(currentUserData.role);
    }
  }, [currentUserData]);

  useEffect(() => {
    const cookie = cookies.get("jwt");
    if (!cookie) {
      dispatch(cleanStore());
    }
  });

  useEffect(() => {
    //dispatch(getActiveCategories());
    //dispatch(getActiveProcessors());
    //dispatch(getRecipientAndSenders());
    dispatch(setCertainCategoryValueTo0());
    dispatch(manuallyTrigerRole);
  }, [dispatch]);
  return (
    <div className={css.container}>
      <BrowserRouter>
        <Header />

        <Route exact path="/signup" component={RegisterPage} />
        <Route exact path="/signin" component={LoginPage} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/change-password" component={ChangePassword} />

        <ProtectedRoute path="/basic-account" component={BasicAccount} />
        <ProtectedRoute path="/processors" component={Processors} />
        <ProtectedRoute path="/categories" component={Categories} />
        <ProtectedRoute
          path="/see-word-document"
          component={CreationWordDocument}
        />
        <ProtectedRoute path="/record-book" component={RecordBook} />
        <ProtectedRoute exact path="/" component={Papers} />
        <ProtectedRoute path="/archive" component={Archive} />
        <ProtectedRoute
          exact
          path="/not-archived-papers"
          component={NotArchivedPapers}
        />
        <ProtectedRoute path="/create-archive" component={CreateArchive} />
        <ProtectedRoute path="/destroy-archive" component={DestroyArchive} />
        <ProtectedRoute path="/user-panel" component={UserPanel} />
        <ProtectedRoute path="/edit-paper" component={EditPaper} />
        <ProtectedRoute path="/edit-archive" component={EditArchive} />
        <ProtectedRoute path="/document-creation" component={ReactDocx} />
        <ProtectedRoute
          path="/document-creation-archive"
          component={ReactDocxArchive}
        />
        <ProtectedRoute path="/add-archive" component={AddArchive} />
        <ProtectedRoute path="/patterns" component={DocumentPatterns} />
        {currentUserRole === "admin" && (
          <>
            <ProtectedRoute path="/all-users" component={AllUsers} />
            <ProtectedRoute path="/user-profile" component={UserProfile} />
          </>
        )}

        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;
